import { FC, useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import triggerTracking from '@blueprint/tracking/dist/Tracking';
import { Tabs, Tab } from '@zoopla/shared/components';
import { RegTabsContainer } from './RegTabs.styles';
import RegisterSection from '../section/Register';
import { SocialAuthProps } from '../AuthModal.types';

const SignInSection = dynamic(() => import('../section/SignIn'), {
    ssr: false
});

const signInTitleTn = 'Sign In';
const registerTitleTn = 'Register';

export const RegTabs: FC<React.PropsWithChildren<SocialAuthProps>> = (
    props
) => {
    const activeTabRef = useRef<HTMLButtonElement>(null);

    const {
        initialMode = 'register',
        actionAfterAuth,
        resetActionAfterAuth = () => null,
        isShowing,
        onSocialAuth,
        close,
        setCurrentStep
    } = props;

    useEffect(() => {
        const selectedTab = activeTabRef.current;

        const timeoutFocus = setTimeout(() => {
            selectedTab?.focus();
        }, 200);

        return () => clearTimeout(timeoutFocus);
    }, [props.initialMode]);

    return (
        <RegTabsContainer>
            <Tabs
                initialIndex={initialMode === 'sign-in' ? 1 : 0}
                ariaLabel="auth-tab"
                isFullWidth
                handleClick={(tabIndex) =>
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'registration',
                        eventAction: tabIndex
                            ? 'click_to_signin'
                            : 'click_to_register',
                        eventLabel: actionAfterAuth?.eventLabel
                    })
                }
                ref={activeTabRef}
            >
                <Tab label={registerTitleTn}>
                    <RegisterSection
                        {...props}
                        close={close}
                        actionAfterAuth={actionAfterAuth}
                        resetActionAfterAuth={resetActionAfterAuth}
                        onSocialAuth={onSocialAuth}
                        setCurrentStep={setCurrentStep}
                    />
                </Tab>
                <Tab label={signInTitleTn}>
                    <SignInSection
                        {...props}
                        isShowing={isShowing}
                        close={close}
                        actionAfterAuth={actionAfterAuth}
                        resetActionAfterAuth={resetActionAfterAuth}
                        onSocialAuth={onSocialAuth}
                    />
                </Tab>
            </Tabs>
        </RegTabsContainer>
    );
};
